import { Component, OnInit, Inject, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.css']
})
export class AppLayoutComponent implements OnInit {
  cssloaded = false;
  isProduction = true;
  _baseUrl: string;
  //public _sanitizer;

  constructor(private router: Router, public sanitizer: DomSanitizer, @Inject('BASE_URL') baseUrl: string, private renderer: Renderer2) {
    this._baseUrl = baseUrl;
    this.renderer.removeClass(document.body, 'body-class-login');
    this.renderer.addClass(document.body, 'body-class');
  }

  ngOnInit() {
    if (this.cssloaded == false) {
      this.cssloaded = true;
    }
  }

  stop(element:Event) {
    event?.stopPropagation();
  }
}
